import type { Messages } from '../en'

export const theater: Messages['theater'] = {
  runVisualization: 'Visualização da execução',
  replay: 'Reprisar',
  showWorkshop: 'Mostrar fábrica',
  hide: 'Ocultar',
  warmingUp: 'Preparando a fábrica…',
  overflowMore: (n) => `+${n}`,
  stageLoading: (pct) => `preparando o palco… ${pct}%`
}
